import { OutlinedInput } from '@material-ui/core';
import React from 'react';
import useStyles from '../styles';
import SearchIcon from '@material-ui/icons/Search';

type SearchBarProps = {
  searchText: string;
  placeholder?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};
const SearchBar = (props: SearchBarProps) => {
  const styles = useStyles();
  const { searchText, onChange, placeholder } = props;
  return (
    <OutlinedInput
      onClick={e => e.stopPropagation()}
      value={searchText}
      onChange={onChange}
      placeholder={placeholder ?? t('Search member')}
      endAdornment={<SearchIcon className={styles.searchIcon} />}
      inputProps={{
        className: styles.projectGridSearchInput,
      }}
      className={styles.projectGridSearchContainer}
    />
  );
};

export default SearchBar;
